import { getJson } from 'utils/http';

export type UserLocation = {
  locationText: string | null | undefined;
  stateCode: string | null | undefined;
  countryCode: string | null | undefined;
  latitude: number | null | undefined;
  longitude: number | null | undefined;
};

export function fetchUserLocation(): Promise<UserLocation> {
  return getJson('/data/user-location').then(
    // @ts-expect-error TS(2345): Argument of type '({ location }: { location: any; ... Remove this comment to see the full error message
    ({ location }) => location,
  );
}
